<template>
  <div class="mainDiv">
    <spinner-component :loading="loading"></spinner-component>
    <error-dialog-component :model-value="this.errorDialog"></error-dialog-component>
    <image-selection-dialog :model-value="imageSelectionDialog"></image-selection-dialog>

    <v-container>
      <v-row>
        <v-col>
          <v-text-field
              v-model="template.name"
              label="Nazwa wzoru"
          ></v-text-field>
        </v-col>
        <v-col>
          <v-select
              v-model="template.type"
              :items="emailTypes"
              label="Typ wzoru"
          ></v-select>
        </v-col>
        <v-col>
          <v-btn v-on:click="saveDesign">Zapisz wzór</v-btn>
        </v-col>
      </v-row>
    </v-container>
    <div class="designEdit">
      <div class="container">
        <EmailEditor
            ref="emailEditor"
            v-on:load="editorLoaded"
            v-on:ready="editorReady"
            :options=options
        />
      </div>
    </div>
  </div>
</template>

<script>

import SpinnerComponent from "@/components/SpinnerComponent";
import ErrorDialogComponent from "@/components/ErrorDialogComponent";
import ImageSelectionDialog from "@/components/mails/ImageSelectionDialog";
import {EmailEditor} from "vue-email-editor/src/components";
import {mailsApiClient} from "@/api/mails.api.client";

export default {
  name: 'NewMailDesignerView',

  components: {
    EmailEditor, SpinnerComponent, ErrorDialogComponent, ImageSelectionDialog
  },

  data() {
    return {
      // Email types
      emailTypes: [],
      template: {
        name: '',
        design: undefined,
        type: null
      },

      // MISC
      loading: false,
      errorDialog: {
        errorMessage: "",
        visible: false
      },

      imageSelectionDialog: {
        visible: false,
        doneCallback: undefined
      },

      options: {
        merge_tabs: 'MERGE_TABS'
      }
    }
  },

  created() {
    this.loading = true;
    this.getEmailTypes();
  },

  methods: {
    getEmailTypes() {
      mailsApiClient.getEmailTypes((response) => {
        this.emailTypes = response.data;
      }, () => {
        this.errorDialog.visible = true;
        this.errorDialog.errorMessage = "Błąd pobierania typów emailów!";
      }, () => {
      })
    },

    editorReady() {
      this.loading = false;
      this.$refs.emailEditor.editor.registerCallback('image', (file, done) => {
        this.imageSelectionDialog.doneCallback = done;
        this.imageSelectionDialog.visible = true;
      })

    },
    editorLoaded() {
    },
    saveDesign() {
      this.$refs.emailEditor.editor.saveDesign(
          (design) => {
            this.loading = true;
            this.template.design = design;
            mailsApiClient.saveTemplate(this.template, () => {
                  this.$router.push('/mails-all')
                }, () => {
                  this.errorDialog.visible = true;
                  this.errorDialog.errorMessage = "Błąd podczas dodawania nowego template'u!";
                }, () => this.loading = false
            )
          }
      )
    },
    exportHtml() {
      this.$refs.emailEditor.editor.exportHtml(
          (data) => {
            console.log('exportHtml', data);
          }
      )
    }
  }
};
</script>
<style>
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
}

.mainDiv {
  height: 100%;
}

#app, .mainDiv .designEdit {
  height: 100%;
}

.mainDiv .designEdit .container {
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
}

#bar {
  flex: 1;
  background-color: #40B883;
  color: #FFF;
  padding: 10px;
  display: flex;
  max-height: 40px;
}

#bar h1 {
  flex: 1;
  font-size: 16px;
  text-align: left;
}

#bar button {
  flex: 1;
  padding: 10px;
  margin-left: 10px;
  font-size: 14px;
  font-weight: bold;
  background-color: #000;
  color: #FFF;
  border: 0px;
  max-width: 150px;
  cursor: pointer;
}

#bar a {
  flex: 1;
  padding: 10px;
  margin-left: 10px;
  font-size: 14px;
  font-weight: bold;
  color: #fff;
  border: 0px;
  cursor: pointer;
  text-align: right;
  text-decoration: none;
  line-height: 160%;
}
</style>